import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <Navbar />
      <div className="terms-container">
        <h1>Terms and Community Guidelines</h1>
        
        <section className="terms-section">
          <h2>1. Community Guidelines</h2>
          <p>
            Our platform is committed to fostering a respectful and productive environment for all users.
            To maintain this environment, we expect all members to adhere to the following guidelines:
          </p>
          
          <h3>1.1 Respectful Communication</h3>
          <p>
            Treat others with respect. Disagreements are natural, but personal attacks, harassment,
            and disrespectful language are not tolerated.
          </p>
          
          <h3>1.2 Prohibited Content</h3>
          <p>The following types of content are strictly prohibited:</p>
          <ul>
            <li>Hate speech or discrimination based on race, ethnicity, gender, religion, etc.</li>
            <li>Harassment or bullying of any kind</li>
            <li>Explicit or inappropriate content</li>
            <li>Personal attacks or defamatory statements</li>
            <li>Spam, excessive self-promotion, or misleading information</li>
            <li>Disclosure of private information without consent</li>
            <li>Content that encourages illegal activities</li>
          </ul>
          
          <h3>1.3 Quality Contributions</h3>
          <p>
            We encourage thoughtful and constructive contributions. Queries and comments should aim to 
            provide value to the community.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>2. Content Moderation</h2>
          
          <h3>2.1 AI Moderation</h3>
          <p>
            Our platform uses AI technology to automatically review reported content. This system helps 
            maintain community standards by identifying content that may violate our guidelines.
          </p>
          
          <h3>2.2 Human Moderation</h3>
          <p>
            In addition to AI moderation, our admin team reviews complex cases and appeals. All moderation 
            decisions aim to be fair and consistent with our community guidelines.
          </p>
          
          <h3>2.3 Content Removal</h3>
          <p>
            Content that violates our guidelines may be hidden or removed. Users who repeatedly post 
            inappropriate content may face restrictions or account suspension.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>3. Reporting and Appeals</h2>
          
          <h3>3.1 Reporting Content</h3>
          <p>
            If you encounter content that violates our guidelines, please report it using the report 
            feature. Provide a clear reason for the report to help us review it effectively.
          </p>
          
          <h3>3.2 Review Process</h3>
          <p>
            Reported content is initially reviewed by our AI system. For content that is automatically 
            removed, both the reporter and the content creator will be notified of the decision.
          </p>
          
          <h3>3.3 Appeals</h3>
          <p>
            If you believe your content was incorrectly removed, you have the right to appeal. Appeals 
            are reviewed by our admin team, not the AI system. Please provide a clear explanation of why 
            you believe your content does not violate our guidelines.
          </p>
          
          <h3>3.4 Final Decisions</h3>
          <p>
            While we strive to be fair in all moderation decisions, the platform administrators reserve 
            the right to make final decisions regarding content that may harm the community.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>4. Account and Data</h2>
          
          <h3>4.1 Account Responsibility</h3>
          <p>
            You are responsible for maintaining the security of your account and for all activities 
            that occur under your account.
          </p>
          
          <h3>4.2 Data Privacy</h3>
          <p>
            We respect your privacy and handle your data in accordance with our Privacy Policy. 
            We collect and process only the information necessary to provide and improve our services.
          </p>
          
          <h3>4.3 Content Ownership</h3>
          <p>
            You retain ownership of the content you post, but by posting, you grant us a license to 
            use, store, and display your content in connection with providing our service.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>5. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. We will notify users of significant changes, 
            but we encourage you to review these guidelines periodically.
          </p>
        </section>
        
        <div className="terms-footer">
          <p>Last updated: {new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <p>
            By using our platform, you agree to abide by these terms and community guidelines. 
            Failure to comply may result in content removal or account restrictions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions; 